import { lazy } from 'react'

export const IntegrationAppTopPageLazy = lazy(() => import('./Main'))
